import { useTranslation } from 'next-i18next'
import { makeStyles, Container } from '@material-ui/core'
import T from './tokens'
import Reveal from './Reveal'

const certifications = [
  { src: '/static/img/home-new/certifications/nia.png', altKey: 'certifications.altNia', w: 389, h: 190 },
  { src: '/static/img/home-new/certifications/iso.png', altKey: 'certifications.altIso', w: 226, h: 190 },
  { src: '/static/img/home-new/certifications/omsin.png', altKey: 'certifications.altOmsin', w: 376, h: 162 },
  { src: '/static/img/home-new/certifications/startup-thailand.png', altKey: 'certifications.altStartup', w: 312, h: 190 },
  { src: '/static/img/home-new/certifications/depa.png', altKey: 'certifications.altDepa', w: 285, h: 190 },
]

const useStyles = makeStyles((theme) => ({
  root: {
    padding: '60px 0',
    background: T.color.canvas,
    [theme.breakpoints.down('sm')]: {
      padding: '40px 0',
    },
  },
  heading: {
    fontFamily: T.font.heading,
    fontSize: 28,
    fontWeight: 500,
    color: T.color.ink,
    textAlign: 'center',
    margin: '0 0 8px',
    [theme.breakpoints.down('sm')]: {
      fontSize: 20,
    },
  },
  subtitle: {
    fontFamily: T.font.body,
    fontSize: 20,
    fontWeight: 500,
    color: T.color.brand,
    textAlign: 'center',
    margin: '0 0 40px',
    [theme.breakpoints.down('sm')]: {
      fontSize: 16,
      margin: '0 0 24px',
    },
  },
  logoGrid: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'stretch',
    gap: '16px',
    [theme.breakpoints.down('sm')]: {
      gap: '10px',
    },
  },
  logoItem: {
    background: T.color.surface,
    border: `1px solid ${T.color.line}`,
    borderRadius: T.radius.pill,
    minWidth: 150,
    height: 90,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '12px 28px',
    boxShadow: T.shadow.sm,
    transition: 'transform 0.25s ease, box-shadow 0.25s ease',
    '&:hover': {
      transform: 'translateY(-3px)',
      boxShadow: T.shadow.md,
    },
    // Fixed display HEIGHT + auto width so every badge renders at a uniform
    // height with proportional width, regardless of each PNG's intrinsic
    // aspect. This CSS overrides the img's width/height ATTRIBUTES for layout
    // (the attributes stay only as CLS/aspect-ratio hints for `unsized-images`);
    // maxWidth caps very wide badges so pills don't blow out.
    '& img': {
      height: 48,
      width: 'auto',
      maxWidth: '100%',
      objectFit: 'contain',
    },
    [theme.breakpoints.down('sm')]: {
      minWidth: 110,
      height: 68,
      padding: '8px 16px',
      '& img': {
        height: 36,
        width: 'auto',
      },
    },
  },
}))

const CertificationsNew = () => {
  const classes = useStyles()
  const { t } = useTranslation('home')

  return (
    <section className={classes.root}>
      <Container maxWidth={false} style={{ maxWidth: T.container }}>
        <Reveal>
          <h2 className={classes.heading}>{t('certifications.heading')}</h2>
          <p className={classes.subtitle}>{t('certifications.subtitle')}</p>
        </Reveal>
        <Reveal delay={0.15}>
          <div className={classes.logoGrid}>
            {certifications.map((c) => (
              <div key={c.altKey} className={classes.logoItem}>
                <img src={c.src} alt={t(c.altKey)} width={c.w} height={c.h} loading="lazy" decoding="async" />
              </div>
            ))}
          </div>
        </Reveal>
      </Container>
    </section>
  )
}

export default CertificationsNew
